import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import { Modal, Table, VideoCameraIcon } from "@dealer-center/core-components";
import type {
  ImageTableProps,
  ModelImageRow
} from "@dealer-center/inventory-pages-gvm-interface";
import { useState } from "react";
import { getProvider, isIoF, isVideo } from "./imageHelper";

function tableColumns(
  onOpenModal: (url: string) => void
): TypeSafeTableColumns<ModelImageRow> {
  return [
    {
      key: "provider",
      dataIndex: "provider",
      title: "Provider",
      align: "left"
    },
    {
      key: "url",
      title: "Path",
      width: 300,
      render: (value, record: ModelImageRow) => {
        return (
          <a
            onClick={e => {
              e.preventDefault();
              onOpenModal(record.url);
            }}
          >
            {record.isVideo ? (
              <VideoCameraIcon height={80} title="Video" width={80} />
            ) : (
              <img
                key={record.url}
                loading="lazy"
                src={record.url}
                style={{
                  maxWidth: "250px",
                  minHeight: "100px",
                  objectPosition: "center"
                }}
              />
            )}
          </a>
        );
      }
    },
    {
      key: "width",
      dataIndex: "width",
      title: "Width",
      align: "left"
    },
    {
      key: "height",
      dataIndex: "height",
      title: "Height",
      align: "left"
    },
    {
      key: "shotTypeDescr",
      dataIndex: "shotTypeDescr",
      title: "Shot Type",
      align: "left"
    },
    {
      key: "category",
      dataIndex: "category",
      title: "Category",
      align: "left"
    },
    {
      key: "fileType",
      dataIndex: "fileType",
      title: "File Type",
      align: "left"
    }
  ];
}

export const ImageTable = ({
  images,
  isLoading,
  shotTypeLookup,
  setSelectedImageRows
}: ImageTableProps) => {
  const [showModal, setShowModal] = useState(false);
  const [url, setUrl] = useState("");
  const [selectedRows, setSelectedRows] = useState<ModelImageRow[]>([]);

  const onOpenModal = (url: string) => {
    setUrl(url);
    setShowModal(true);
  };

  const data: ModelImageRow[] = images.map(media => {
    return {
      id: media.url,
      key: media.url,
      url: media.url,
      category: media.category,
      height: media.height,
      width: media.width,
      shotType: media.shotType,
      shotTypeDescr: shotTypeLookup[String(media.shotType)],
      fileType: media.fileType,
      provider: getProvider(media),
      isIoF: isIoF(media),
      isVideo: isVideo(media)
    };
  });

  const disabledRowKeys = data.filter(row => row.isIoF).map(row => row.url);

  return (
    <>
      <Table.Table
        enableRowSelection
        columns={tableColumns(onOpenModal)}
        data={data}
        data-testid="gvm-trim-image-table"
        dataDensity="small"
        disabledSelectedRowKeys={disabledRowKeys}
        displayFilter={true}
        displayPageSizeSelector={true}
        emptyText="No images available"
        enablePagination={true}
        isLoading={isLoading}
        scrollY={500}
        sortableColumns={true}
        tableLayout="auto"
        onChangeSelectedRows={(selectedKeys, selectedRows) => {
          setSelectedRows(selectedRows);
          setSelectedImageRows(selectedRows);
        }}
      />
      <Modal
        header="Vehicle Media"
        show={showModal}
        size="large"
        onHide={() => setShowModal(false)}
      >
        <img key={url} src={url} style={{ maxWidth: "100%" }} />
      </Modal>
    </>
  );
};
